/**
 * Complementary product card - size selector with dynamic price/image updates
 * Only affects cards with data-complementary-card attribute (complementary_enhanced)
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    const value = (cents / 100).toFixed(2);
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return value;
    const formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }

  function initComplementaryCards() {
    document.querySelectorAll('[data-complementary-card]').forEach((card) => {
      if (card.dataset.complementaryCardInit) return;
      card.dataset.complementaryCardInit = 'true';

      const variantsScript = card.querySelector('[data-complementary-card-variants]');
      const sizesContainer = card.querySelector('[data-complementary-card-sizes]');
      const imgEl = card.querySelector('[data-complementary-card-img]');
      const priceWrapper = card.querySelector('[data-complementary-card-price]');
      const variantInput = card.querySelector('[data-complementary-card-variant-input]');
      const submitBtn = card.querySelector('.quick-add__submit');

      if (!variantsScript || !sizesContainer) return;

      let variantsData;
      try {
        variantsData = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      const variants = variantsData.variants || [];
      const moneyFormat = variantsData.money_format || '{{amount}}';

      const variantMap = {};
      variants.forEach((v) => {
        variantMap[v.id] = v;
      });

      const sizeSelect = sizesContainer.querySelector('[data-complementary-card-size-select]');
      if (!sizeSelect) return;

      sizeSelect.addEventListener('change', function () {
        const variantId = parseInt(this.value, 10);
        const variant = variantMap[variantId];
        if (!variant) return;

        if (variantInput) {
            variantInput.value = variant.id;
            variantInput.disabled = !variant.available;
          }

          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            const soldOutSpan = submitBtn.querySelector('.sold-out-message');
            const addSpan = submitBtn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
            if (addSpan) {
              addSpan.textContent = variant.available ? 'ADD' : (soldOutSpan?.textContent || 'Sold out');
            }
          }

          if (imgEl && variant.media_src) {
            imgEl.src = variant.media_src;
            imgEl.srcset = variant.media_srcset || variant.media_src;
          }

          if (priceWrapper) {
            const priceItems = priceWrapper.querySelectorAll('.price-item, [class*="price-item"]');
            const formattedPrice = formatMoney(variant.price, moneyFormat);
            const formattedCompare = variant.compare_at_price > variant.price
              ? formatMoney(variant.compare_at_price, moneyFormat)
              : '';

            if (priceItems.length >= 2 && formattedCompare) {
              priceItems[0].textContent = formattedCompare;
              priceItems[1].textContent = formattedPrice;
              priceItems[0].style.textDecoration = 'line-through';
              priceItems[0].style.display = '';
            } else if (priceItems.length >= 1) {
              priceItems[0].textContent = formattedPrice;
              priceItems[0].style.textDecoration = '';
              if (priceItems[1]) priceItems[1].style.display = 'none';
            } else {
              priceWrapper.innerHTML = '<span class="price"><span class="price-item">' + formattedPrice + '</span></span>';
            }
          }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComplementaryCards);
  } else {
    initComplementaryCards();
  }

  document.addEventListener('shopify:section:load', initComplementaryCards);
})();
